import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton } from 'antd';
import { BlockNames } from '../block.types';

export function addBlocks(piletApi: PiletApi) {
	const LazySolutionListBlock = React.lazy(() => import('./SolutionListBlock'));

	piletApi.registerExtension(BlockNames.SolutionList, props => (
		<React.Suspense fallback={<Skeleton />}>
			<LazySolutionListBlock {...props} />
		</React.Suspense>
	));
}
